import { render, staticRenderFns } from "./exhibition-info-list.vue?vue&type=template&id=22d88d10&scoped=true&"
import script from "./exhibition-info-list.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-list.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-list.vue?vue&type=style&index=0&id=22d88d10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d88d10",
  null
  
)

export default component.exports